import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmberOutlined';

interface DeleteLeadConfirmDialogProps {
  open: boolean;
  leadName: string;
  leadNumber: string;
  errorMessage: string | null;
  submitting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

/** Super Admin-only hard delete (Phase 66) — modeled on
 * ConvertToStudentConfirmDialog.tsx, the codebase's one existing
 * confirmation-dialog convention, reused here rather than reinvented. */
export const DeleteLeadConfirmDialog = ({
  open,
  leadName,
  leadNumber,
  errorMessage,
  submitting,
  onClose,
  onConfirm,
}: DeleteLeadConfirmDialogProps) => (
  <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
    <DialogTitle>Delete lead</DialogTitle>
    <DialogContent>
      <Stack spacing={1.5} sx={{ mt: 1 }}>
        {errorMessage && <Alert severity="error">{errorMessage}</Alert>}
        <Alert severity="warning" icon={<WarningAmberIcon fontSize="small" />}>
          This permanently deletes the lead and every related follow-up,
          appointment, attachment, call/message and history record. This
          cannot be undone.
        </Alert>
        <Typography variant="subtitle1">
          {leadName} ({leadNumber})
        </Typography>
        <Typography variant="body2">Are you sure you want to permanently delete this lead?</Typography>
      </Stack>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button variant="contained" color="error" disabled={submitting} onClick={onConfirm}>
        {submitting ? 'Deleting…' : 'Delete lead'}
      </Button>
    </DialogActions>
  </Dialog>
);
